import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import pt from '../locales/pt.json';
import en from '../locales/en.json';
import es from '../locales/es.json';
import privacyPt from '../locales/privacy-pt.json';
import privacyEn from '../locales/privacy-en.json';
import privacyEs from '../locales/privacy-es.json';
import termsPt from '../locales/terms-pt.json';
import termsEn from '../locales/terms-en.json';
import termsEs from '../locales/terms-es.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pt: {
        translation: pt,
        privacy: privacyPt.privacy,
        terms: termsPt.terms,
      },
      en: {
        translation: en,
        privacy: privacyEn.privacy,
        terms: termsEn.terms,
      },
      es: {
        translation: es,
        privacy: privacyEs.privacy,
        terms: termsEs.terms,
      },
    },
    fallbackLng: 'pt',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage'],
      cookieMinutes: 160,
    },
  });

export default i18n;
